function CreditCostText(props) {
  if (props.cost === 0) {
    return "FREE";
  }

  const creditText = props.cost > 1 ? "credits" : "credit";

  return `${props.cost} ${creditText}`;
}

export default CreditCostText;
